export enum LiveCardType {
    RECENT = "recent",
    TOPSONG = "topsong",
    MICROSITE = "microsite",
    ONAIR = "onair",
    LISTENING_EXPERIENCE = "listening",
}
